import { useRouter } from "next/router"
import { useEffect } from "react"

const useRouteChangeComplete = (listener: () => void) => {
  const router = useRouter()
  useEffect(() => {
    router.events.on("routeChangeComplete", listener)
    return () => router.events.off("routeChangeComplete", listener)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listener])
}

export default useRouteChangeComplete
